export enum Provider {
  Twitch = "twitch",
}
